define('editor/edit/layers/edit/vectors',['plugins/http', 'durandal/app', 'jquery', 'knockout', 'knockout-mapping', 'no-ui-slider', 'tinycolorpicker'], function (http, app, $, ko, komapping, noUiSlider) {
    var viewmodel = function () {
        var self = this;

        self.id = ko.observable();
        self.name = ko.observable();

        self.backupName = null;
        self.childLayerBackups = [];
        self.isDirty = true;
        
        self.fillColour = ko.observable();
        self.strokeColour = ko.observable();
        self.strokeWeight = ko.observable();
        self.selectedStrokeWeight = ko.observableArray([]);
        self.strokeOpacity = ko.observable();
        self.fillOpacity = ko.observable();

        self.activate = function (editorMapId, group, layers, backToListFunc) {
            // cannot edit shapes, just colour / opacity etc
            self.editorMapId = editorMapId;
            self.group = group;
            self.id(group.id());
            self.name(group.name());
            self.nameBackup = group.name();
            self.layers = layers;

            self.backupChildLayers();

            // defaults: use first layer in group
            var firstLayer = self.layers[0];
            self.fillColour(firstLayer.state().properties.fillColor() || firstLayer.state().properties.color());
            self.strokeColour(firstLayer.state().properties.color());
            self.strokeWeight(firstLayer.state().properties.weight());
            self.selectedStrokeWeight.push('' + firstLayer.state().properties.weight());
            self.strokeOpacity(firstLayer.state().properties.opacity() * 100);
            self.fillOpacity(firstLayer.state().properties.fillOpacity() * 100);
            
            self.exit = backToListFunc;
            
            self.changes = ko.computed(function () {
                // want to be notified of changes to these properties
                return self.fillColour() +
                    self.strokeColour() +
                    self.selectedStrokeWeight()[0] +
                    self.strokeOpacity() +
                    self.fillOpacity();
            });

            self.changes.subscribe(function() {
                // update child layers observables and notify
                var layersLen = self.layers.length;

                for (var i = 0; i < layersLen; i++) {
                    var layer = self.layers[i];
                    
                    layer.state().properties.fillColor(self.fillColour());
                    layer.state().properties.color(self.strokeColour());
                    layer.state().properties.weight(self.selectedStrokeWeight()[0]);
                    layer.state().properties.stroke(self.selectedStrokeWeight()[0] > 0);
                    layer.state().properties.opacity(self.strokeOpacity() / 100);
                    layer.state().properties.fillOpacity(self.fillOpacity() / 100);
                }

                app.trigger("layers:updated", self.layers);
            });
            
            app.on('layers:drawing', function () {
                self.cancelCommand();
            });
        };

        self.backupChildLayers = function () {
            var layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];

                self.childLayerBackups.push(ko.toJS(layer));
            }
        };

        self.detached = function () {
            if (self.isDirty) {
                self.cancelCommand();
            }
        };

        self.compositionComplete = function() {
            // set up jQuery plugins etc..
            var fillSlider = $('.slider-fill'),
                fillSliderStart = self.fillOpacity(),
                strokeSlider = $('.slider-stroke'),
                strokeSliderStart = self.strokeOpacity(),
                fillColourPickerElement = $('.color-picker-fill'),
                fillColourPicker,
                strokeColourPicker;

            noUiSlider.create(fillSlider.get(0),
            {
                start: fillSliderStart,
                step: 1,
                tooltips: true,
                connect: "lower",
                orientation: "horizontal",
                range: {
                    'min': 0,
                    'max': 100
                },
                serialization: {
                    format: {
                        decimals: 0
                    }
                }
            });

            fillSlider.get(0).noUiSlider.on('change', function () {
                var newValue = fillSlider.get(0).noUiSlider.get();
                self.fillOpacity(newValue);
            });

            noUiSlider.create(strokeSlider.get(0),
            {
                start: strokeSliderStart,
                step: 1,
                tooltips: true,
                connect: "lower",
                orientation: "horizontal",
                range: {
                    'min': 0,
                    'max': 100
                },
                serialization: {
                    format: {
                        decimals: 0
                    }
                }
            });

            strokeSlider.get(0).noUiSlider.on('change', function () {
                var newValue = strokeSlider.get(0).noUiSlider.get();
                self.strokeOpacity(newValue);
            });

            strokeColourPicker = $('.color-picker-stroke').tinycolorpicker();
            strokeColourPicker.data().plugin_tinycolorpicker.setColor(self.strokeColour());
            strokeColourPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.strokeColour(newColour);
            });

            if (fillColourPickerElement.length) {
                fillColourPicker = $('.color-picker-fill').tinycolorpicker();
                fillColourPicker.data().plugin_tinycolorpicker.setColor(self.fillColour());
                fillColourPicker.bind("change", function () {
                    var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                    self.fillColour(newColour);
                });
            }
        };

        self.saveCommand = function () {
            self.group.name(self.name());

            self.save()
                .then(function() {
                    // app.trigger('layer:saved', self.layer);
                    self.isDirty = false;
                    self.exit();
                })
                .fail(app.showError);
        };

        self.cancelCommand = function () {
            if (!self.isDirty) {
                return;
            }
            
            // revert to initial layer state, for each layer
            var layersLen = self.layers.length,
                layer,
                backup,
                mappedState;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];
                backup = self.childLayerBackups[i];
                mappedState = komapping.fromJS(backup.state);

                delete mappedState['__ko_mapping__'];
                
                layer.state(mappedState);
            }

            self.group.name(self.nameBackup);
            app.trigger("layers:updated", self.layers);
            self.isDirty = false;
            self.exit();
        };

        self.save = function () {
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: self.group.id(),
                    groupName: self.group.name(),
                    groupCollapsed: self.group.isCollapsed(),
                    childLayerStates: {}
                },
                layersLen = self.layers.length,
                layer;

            for (var i = 0; i < layersLen; i++) {
                layer = self.layers[i];

                data.childLayerStates[layer.id()] = ko.toJS(layer.state());
            }

            return http.post(url, data)
                .fail(app.showError);
        };
    };

    return viewmodel;
});

